import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { selectLabels } from '../../redux/configuration/selectors'
import { formatPriceByLanguage } from '../../redux/configuration/utilities'
import { selectBookingState } from '../../redux/booking/selectors'
import BookingReminders from '../../components/BookingReminders/BookingReminders'
import BookingConfirmationTable from '../../components/BookingConfirmation/BookingConfirmationTable'
import { appRoutes } from '../../configuration/constants'

import '../../styles/scss/components/booking-confirmation/booking-confirmation.scss'
import { clearActiveModifyBooking } from '../../redux/modifyBooking/actions'
import { selectLanguage } from '../../redux/session/selectors'

const BookingSuccessConfirmation = ({ handleRouteChange }) => {
  const location = useLocation()
  const labels = useSelector(selectLabels)
  const lang = useSelector(selectLanguage)
  const bookingData = useSelector(selectBookingState)
  const dispatch = useDispatch()
  const data = bookingData?.data
  const tableData = [
    {
      label: labels.bookingNumber,
      value: bookingData?.data?.bookingNumber
    },
    {
      label: labels.transactionStatus,
      value: labels[data?.paymentStatus]
    },
    {
      label: labels.bookingStatus,
      value: location?.state?.skippedPayment
        ? labels.bookingPaymentCodeActive
        : labels[data?.bookingStatus]
    }
  ]

  if (data?.refundApplied) {
    tableData.push({
      label: labels.totalRefund,
      value: formatPriceByLanguage(data?.refundAmount, lang)
    })
  }

  return (
    <div className="booking-confirmation">
      <div className="u-container">
        <div className="booking-confirmation-content">
          <div className="booking-confirmation-container">
            <h2 className="theme-font-header">{labels.bookingConfirmtion}</h2>
            <>
              {data?.refundApplied && <BookingReminders labels={labels} />}
              <BookingConfirmationTable
                headerLabel={labels.transactionApproved}
                tableData={tableData}
                centerHeader
              />
            </>
          </div>
        </div>
        <div className="booking-confirmation__submits">
          <button
            className="btn btn-primary large-primary-btn"
            onClick={() => {
              dispatch(clearActiveModifyBooking())
              handleRouteChange(appRoutes.ferryRoutes.pathname)
            }}
          >
            {labels.newBookingBtn || labels.continueBtn}
          </button>
          <button
            className="btn btn-primary large-primary-btn"
            onClick={() => {
              dispatch(clearActiveModifyBooking())
              handleRouteChange(appRoutes.account.pathname)
            }}
          >
            {labels.myAccountBtn}
          </button>
        </div>
      </div>
    </div>
  )
}

export default BookingSuccessConfirmation
